/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureResourceBatchResponse {
    getFixupPrototypeFunction() { return TagPostureResourceBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<TagPostureResourceBatchResponse>): TagPostureResourceBatchResponse {
        let obj = Object.assign(new TagPostureResourceBatchResponse(), model);
        TagPostureResourceBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureResourceBatchResponse>): TagPostureResourceBatchResponse {
        if (!model) return null;
        return TagPostureResourceBatchResponse.newInstance(<TagPostureResourceBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureResourceBatchResponse) {
        if (!obj) return;

        models.TagPostureResourceBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureResourceBatchResponse): boolean {
        Object.setPrototypeOf(obj, TagPostureResourceBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TagPostureResource.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TagPostureResource; };

}
